<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <loader v-show="loading"/>
        <CCardHeader> <CIcon name="cil-grid" />Slider List
          <div class="card-header-actions">
            <CLink href="#" class="card-header-action btn-setting">
              <a @click="addUser">
                <CIcon name="cil-plus" />
              </a>
            </CLink>
          </div>
        </CCardHeader>
        <CCardBody>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th width="5">No</th>
                <th width="10">Order</th>
                <th>Picture</th>
                <th>Created At</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, k) in data" :key="k">
                <td>
                  <table-number
                    :index="k"
                    :page="paginate.page"
                    :size="paginate.size"
                  />
                </td>
                <td>{{ v.order }}</td>
                <td>
									<img :src="v.url" width="300"/>
								</td>
                <td>
									{{v.created_at | dateTimeFormat}}
									<br>
									<label class="status failed" v-if="v.deleted_at">Terhapus</label>
								</td>
                <td>
                  <btn-edit @click="doEdit(v.id)"/>
                  <btn-delete @click="doDelete(v.id)"/>
                </td>
              </tr>
            </tbody>
          </table>
        </CCardBody>
        <CCardFooter>
          <content-pagination
            :page="paginate.page"
            :size="paginate.size"
            :total="paginate.total"
            @input="changePage"
          />
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import TableNumber from "../../components/TableNumber";
import ContentPagination from "../../components/ContentPagination";
import BtnEdit from "../../components/BtnEdit"
import BtnDelete from "../../components/BtnDelete"
import Loader from '../../components/Loader.vue';
import { showErrorMessage } from '../../lib/helpers';
export default {
  components: {
    TableNumber,
    ContentPagination,
    BtnEdit,
    BtnDelete,
    Loader,
  },
  data() {
    return {
      data: {},
      paginate: {},
      loading: true
    };
  },
  created() {
    this.getList(1);
  },
  methods: {
    getList(page) {
      this.loading = true;
      HTTPAUTH.get(`/api/v1/admin/slider?page=${page}&size=2`).then((res) => {
        this.loading = false;
        this.data = res.data.data;
        this.paginate = res.data.paginate;
      }).catch(() => {
        this.loading = false;
      });
    },
    changePage(p) {
      this.getList(p);
    },
    addUser() {
      this.$router.push({path: "/slider/0"})
    },
    doEdit(id) {
      this.$router.push({path: "/slider/" + id, query: {id: id}})
    },
    doDelete(id) {
      HTTPAUTH.delete("/api/v1/admin/slider/" + id).then(() => {
        this.$toasted.success("Data berhasil dihapus").goAway();
				this.getList(1)
      }).catch(eres => {
        showErrorMessage(eres)
      })
    }
  },
};
</script>